import * as React from 'react';
import { ripeLemon } from '#/colors';

const WarningIcon = ({
  color = ripeLemon,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & { color?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 22" {...props}>
    <g fill="none" fillRule="evenodd" stroke={color}>
      <path
        strokeWidth={2}
        d="M9.205 2.976 1.36 16.406c-1.02 1.746.255 3.927 2.294 3.927h15.693c2.04 0 3.315-2.181 2.295-3.927l-7.847-13.43c-1.019-1.746-3.569-1.746-4.589 0Z"
      />
      <path
        fill={color}
        fillRule="nonzero"
        d="M12.123 6.848v4.05c0 .213-.005.42-.014.623-.01.203-.021.407-.035.613l-.024.311-.03.319c-.02.215-.046.445-.074.69h-.85l-.052-.47-.051-.539-.024-.311c-.014-.206-.026-.41-.035-.613-.01-.203-.015-.41-.015-.623v-4.05h1.204Zm-1.508 9.368a.9.9 0 0 1 .255-.63.92.92 0 0 1 .28-.192.853.853 0 0 1 .35-.07c.123 0 .237.023.343.07a.92.92 0 0 1 .471.475.86.86 0 0 1 .071.347.853.853 0 0 1-.07.35.92.92 0 0 1-.192.28.87.87 0 0 1-.623.255.87.87 0 0 1-.885-.885Z"
      />
    </g>
  </svg>
);
export default WarningIcon;
